export const environment = {
  auth: {
    clientId: "523ad304-12aa-413e-a37a-592c131ce581",
    tenantId: "1a47d566-67d6-448f-93dc-19565d759c26"
  },
  apiUrl: window.location.origin + "/api",
  apiScope: "api://5c0365a2-d4c7-4e52-b157-fe2b138fefb8/.default",
  headerEnvironmentInfo: "TEST",
  appInsights: {
    instrumentationKey: 'd308f71b-b8f9-4e84-b45f-2d62602208fd',
    disableAjaxTracking: false
  }
};
